import React, { useState, useEffect, useRef } from 'react';
import './contacts.css';

// Images
import Plus from './picture/blackPlus.png';
import Sort from './picture/Sort.png';
import Expand from './picture/smanji.png';
import Search from './picture/lupa.png';
import Location from './picture/cioda.png';
import Phone from './picture/telefon.png';
import Link from "./picture/Link.png";
import Dots from "./picture/dots.png";
import Edit from "./picture/edit.png";
import Slanje from "./picture/slanje.png";
import Share from "./picture/Share.png";
import Delete from "./picture/close.png";
import Mail from "./picture/mail.png";
import Question from "./picture/question.png";
import Star from "./picture/star.png";

import Message from '../../picture/1.png';

import User from "./picture/User.png";
import Company from "./picture/House.png";
import Both from "./picture/HomeUser.png";
import Copy from "./picture/copy.png";
import StarGreen from "./picture/favorite.png";

import axios from 'axios';
import { useGlobalContext } from '../../../Context/Context';
import SingleProvider from "./SingleProvider";
import Modal from './Modal';


function Contacts({ setCheckBack, checkBack, selectedCompany, currentTab, setCurrentTab, onLocationClick }) {

    const [selectedProviderId, setSelectedProviderId] = useState(null);
    const wrapperRef = useRef(null); // Ref for the wrapper containing all buttons

    const [providers, setProviders] = useState([]);

        // Fetch providers from the backend
        useEffect(() => {
            const fetchProviders = async () => {
                try {
                    const response = await axios.get(
                        "https://data.nadzor.app/api/admin_panel/provider/readTypes.php"
                    );
    
                    if (response.data.status === 200) {
                        setProviders(response.data.providers);
                    } else {
                        console.error("Error fetching providers:", response.data.message);
                    }
                } catch (error) {
                    console.error("Error fetching providers:", error);
                }
            };
    
            fetchProviders();
        }, []);

    const handleButtonClick = (providerId, index) => {
        setSelectedProviderId((prevSelectedId) =>
            prevSelectedId === providerId ? null : providerId
        );

        // Scroll the button into view
        const targetButton = wrapperRef.current.querySelectorAll(".provider-item")[index];
        if (targetButton) {
            targetButton.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };


    const [data, setData] = useState([]);
    const { setCurrentChatAdmin } = useGlobalContext();
    const interval = useRef(null);

    const fetchContacts = async () => {
        try {
            const response = await axios.get(
                "https://data.nadzor.app/api/admin_panel/cc/read.php?id=" + 1
            );
            if (response.data.status === 200) {
                // Ensure `favorite` is always treated as an integer (0 or 1)
                const contactsWithFavorites = response.data.contacts.map(contact => ({
                    ...contact,
                    favorite: contact.favorite ? 1 : 0, // Convert to number if needed
                }));

                setData(contactsWithFavorites);
                setFilteredContacts(contactsWithFavorites);
            } else {
                console.error("Error fetching contacts:", response.data.message);
                setData([]);
                setFilteredContacts([]);
            }
        } catch (error) {
            console.error("Error during fetch:", error);
        }
    };


    useEffect(() => {
        if (selectedCompany) {
            fetchContacts();
        }
    }, [selectedCompany]);

    const [filteredContacts, setFilteredContacts] = useState(data || []);
    const [searchInput, setSearchInput] = useState(''); // Stores input value
    const [activeSearchField, setActiveSearchField] = useState(null); // Tracks active search field (e.g., 'phone')
    const [visibleField, setVisibleField] = useState(null); // Tracks the currently visible field

    // State to track if all contacts are expanded
    const [areAllExpanded, setAreAllExpanded] = useState(false);

    // State to track expanded contacts (individual or all)
    const [expandedContactId, setExpandedContactId] = useState(null);

    // State to track sorting
    const [isSorted, setIsSorted] = useState(false);


    const [isFavoriteTemporary, setIsFavoriteTemporary] = useState(false);
    const [isFavorite, setIsFavorite] = useState(false); // Tracks favorite state

    // State to track visible footers
    const [visibleFooterIds, setVisibleFooterIds] = useState([]);

    // State to toggle the search bar visibility
    const [isSearchActive, setIsSearchActive] = useState(false);

    const [isAddActive, setIsAddActive] = useState(false); // Add form visibility
    const [disabledButtons, setDisabledButtons] = useState(false); // Disables other buttons

    const [isExpandTemporary, setIsExpandTemporary] = useState(false);


    const [filterMode, setFilterMode] = useState('both'); // 'both', 'personal', 'company'

    const [newContact, setNewContact] = useState({
        name: '',
        desc: '',
        phones: [['', '']], // Two default inputs
        emails: [['', '']], // Two default inputs
        locations: [['', '']], // Two default inputs
        links: [['', '']], // Two default inputs
        type: '', // No type selected by default
        favorite: false, // Not a favorite by default
    });

    const toggleAddForm = () => {

    };
    const handleLocationClick = (location) => {
        if (onLocationClick) {
            onLocationClick(location); // Pass the location to the parent
        }
    };


    // const handleCheckRegistered = (e, contact) => {
    //     // provera - da li je taj email registrovan
    //     // ako jeste  
    //     // ako nije 
    //     console.log(e, contact);
    //     //stopPropagation(); // Prevent collapse/expand
    //     if (contact) {
    //         toggleFooter(contact.id); // Toggle footer visibility
    //         handleCheckRegistered()
    //         setCurrentTab("MESSAGES")
    //         //setCurrentChat()...
    //     }
    // }

    const handleSelectMessage = async (message) => {
        console.log("🔍 Selecting Message:", message);

        if (!message.cr_id) {
            console.error("❌ Error: `chat_room_id` is null.");
            return; // Prevent fetching messages if chat ID is missing
        }

        try {
            const { data } = await axios.post(
                "https://data.nadzor.app/api/admin_panel/chat/getAllMessages.php",
                {
                    chat_room_id: parseInt(message.cr_id),
                    api_key_company: selectedCompany.external_api_key,
                    external_user_id: selectedCompany.company_chat_profile_id,
                }
            );

            console.log("📩 Messages Fetched:", data);

            if (data.status === 200) {
                let newChat = {
                    ...message,
                    messages: data.messages
                };

                console.log("✅ Updating currentChatAdmin:", newChat);
                setCurrentChatAdmin(newChat); // ✅ Ensure chat updates correctly
                setCheckBack(true); // ✅ Trigger UI update if needed
            }
        } catch (e) {
            console.error("⚠️ Error fetching messages:", e);
        }
    };


    const [isModalOpen, setIsModalOpen] = useState(false); // Controls modal visibility
    const [pendingEmail, setPendingEmail] = useState(null); // Stores email before confirmation
    

    // const handleCheckRegistered = async (e, contact) => {
    //     e.stopPropagation(); // Prevent expanding the contact

    //     if (!contact.emails || contact.emails.length === 0) {
    //         alert("⚠️ This contact has no email addresses.");
    //         return;
    //     }

    //     try {
    //         let chatProfileId = null;

    //         // 🔍 Find chat profile by email
    //         for (const email of contact.emails) {
    //             const profileResponse = await axios.post(
    //                 "https://data.nadzor.app/api/admin_panel/cc/findProfileByEmail.php",
    //                 { user_email: email }
    //             );

    //             if (profileResponse.data.profile) {
    //                 chatProfileId = profileResponse.data.profile.cp_id;
    //                 break; // Stop searching once a valid profile is found
    //             }
    //         }

    //         if (chatProfileId) {
    //             // 🏠 Check if a chat room already exists
    //             const roomResponse = await axios.post(
    //                 "https://data.nadzor.app/api/admin_panel/cc/findRoom.php",
    //                 {
    //                     profile1_id: 108, // Your chat profile ID
    //                     profile2_id: chatProfileId, // Contact's chat profile ID
    //                 }
    //             );

    //             if (roomResponse.data.chat_room) {
    //                 console.log("✅ Existing chat room found. Opening chat...");
    //                 handleSelectMessage(roomResponse.data.chat_room); // ✅ Open the chat
    //                 setCurrentTab("MESSAGES"); // ✅ Switch to Messages tab
    //             } else {
    //                 alert("⚠️ No existing chat room. Opening email instead.");
    //                 window.location.href = `mailto:${contact.emails[0]}`;
    //             }
    //         } else {
    //             alert("⚠️ No chat profile found. Opening email...");
    //             window.location.href = `mailto:${contact.emails[0]}`;
    //         }
    //     } catch (error) {
    //         console.error("⚠️ Error checking email:", error.response?.data || error.message);
    //     }
    // };


    const handleCheckRegistered = async (e, contact) => {
        e.stopPropagation(); // Prevent expanding the contact
    
        if (!contact.emails || contact.emails.length === 0) {
            alert("⚠️ This contact has no email addresses.");
            return;
        }
    
        try {
            let chatProfileId = null;
    
            // 🔍 Find chat profile by email
            for (const email of contact.emails) {
                const profileResponse = await axios.post(
                    "https://data.nadzor.app/api/admin_panel/cc/findProfileByEmail.php",
                    { user_email: email }
                );
    
                if (profileResponse.data.profile) {
                    chatProfileId = profileResponse.data.profile.cp_id;
                    break;
                }
            }
    
            if (chatProfileId) {
                // 🏠 Check if a chat room already exists
                const roomResponse = await axios.post(
                    "https://data.nadzor.app/api/admin_panel/cc/findRoom.php",
                    {
                        profile1_id: 108, // Your chat profile ID
                        profile2_id: chatProfileId, // Contact's chat profile ID
                    }
                );
    
                if (roomResponse.data.chat_room) {
                    console.log("✅ Existing chat room found. Opening chat...");
                    handleSelectMessage(roomResponse.data.chat_room);
                    setCurrentTab("MESSAGES");
                } else {
                    console.warn("⚠️ No existing chat room. Asking for confirmation...");
                    setPendingEmail(contact.emails[0]); // Store email
                    setIsModalOpen(true); // Open confirmation modal
                }
            } else {
                console.warn("⚠️ No chat profile found. Asking for confirmation...");
                setPendingEmail(contact.emails[0]); // Store email
                setIsModalOpen(true); // Open confirmation modal
            }
        } catch (error) {
            console.error("⚠️ Error checking email:", error.response?.data || error.message);
        }
    };
    const handleModalConfirm = () => {
        if (pendingEmail) {
            window.location.href = `mailto:${pendingEmail}`;
        }
        setIsModalOpen(false); // Close modal
        setPendingEmail(null); // Reset stored email
    };
    
    useEffect(() => {
        const filtered = data.filter((contact) => {
            if (filterMode === 'both') return true;
            if (filterMode === 'personal') return contact.type === 'person';
            if (filterMode === 'company') return contact.type === 'company';
            return false;
        });
        setFilteredContacts(filtered);
    }, [filterMode, data]);

    const handleAddButtonClick = () => {
        setIsAddActive((prev) => {
            if (!prev) {
                // If activating the form, reinitialize `newContact`
                setNewContact({
                    name: '',
                    desc: '',
                    phones: [['', '']],
                    emails: [['', '']],
                    locations: [['', '']],
                    links: [['', '']],
                });
            }
            return !prev; // Toggle form visibility
        });
        setIsEditing(false);
        setEditingContactId(null);
    };
    const toggleContact = (id) => {
        if (areAllExpanded) {
            setAreAllExpanded(false);
        }

        // Ensure valid contact ID
        const contactExists = data.some((contact) => contact.id === id);
        if (!contactExists) return;

        setExpandedContactId((prevId) => (prevId === id ? null : id));
    };

    const toggleSort = () => {
        const newIsSorted = !isSorted;

        const sortedData = [...data].sort((a, b) => {
            if (newIsSorted) {
                return a.name.localeCompare(b.name); // Ascending order
            } else {
                return b.name.localeCompare(a.name); // Descending order
            }
        });

        setIsSorted(newIsSorted);
        setData(sortedData);
        setFilteredContacts(sortedData); // Ensure filteredContacts is also sorted
    };
    const toggleFooter = (id) => {
        setVisibleFooterIds((prevIds) =>
            prevIds.includes(id) ? prevIds.filter((footerId) => footerId !== id) : [...prevIds, id]
        );
    };
    useEffect(() => {
        applyFilters(searchInput, filterMode);
    }, [filterMode]); // Re-run filter when filterMode changes

    const toggleFilterMode = () => {
        setFilterMode((prevMode) => {
            let newMode;
            if (prevMode === 'both') newMode = 'personal';
            else if (prevMode === 'personal') newMode = 'company';
            else newMode = 'both';

            applyFilters(searchInput, newMode); // Apply updated filter

            return newMode;
        });
    };


    const applyFilters = (searchTerm, mode) => {
        const lowerCaseSearch = searchTerm.toLowerCase();

        const filtered = data.filter((contact) => {
            // Match contact type
            const typeMatch =
                mode === 'both' ||
                (mode === 'personal' && contact.type === 'person') ||
                (mode === 'company' && contact.type === 'company');

            // Match search term
            const searchMatch =
                contact.name.toLowerCase().includes(lowerCaseSearch) ||
                contact.desc.toLowerCase().includes(lowerCaseSearch) ||
                contact.phones.some((phone) => phone.includes(lowerCaseSearch)) ||
                contact.emails.some((email) => email.toLowerCase().includes(lowerCaseSearch)) ||
                contact.address.some((addr) => addr.toLowerCase().includes(lowerCaseSearch)) ||
                contact.links.some((link) => link.toLowerCase().includes(lowerCaseSearch));

            return typeMatch && searchMatch; // Must match both filters
        });

        setFilteredContacts(filtered);
    };



    const toggleExpandAll = () => {
        if (areAllExpanded) {
            // Collapse all contacts
            setAreAllExpanded(false);
            setExpandedContactId(null);
        } else {
            // Expand all contacts
            setAreAllExpanded(true);
            setExpandedContactId("all");
        }

        // Temporarily activate button
        setIsExpandTemporary(true);
        setTimeout(() => {
            setIsExpandTemporary(false);
        }, 200); // Adjust time if needed
    };
    const handleSearchInput = (e) => {
        const searchTerm = e.target.value;
        setSearchInput(searchTerm); // Update state

        applyFilters(searchTerm, filterMode); // Apply live filtering
    };





    const handleSearchToggle = () => {
        setIsSearchActive((prev) => {
            if (prev) {
                setFilteredContacts(data); // Reset to the original contact list
            }
            return !prev; // Toggle the search bar visibility
        });
    };

    const handleShare = (contact) => {
        const shareData = {
            title: `Contact: ${contact.name}`,
            text: `Here are the details for ${contact.name}:
Description: ${contact.desc}
Phones: ${contact.phones.join(', ')}
Emails: ${contact.emails.join(', ')}
Address: ${contact.address.join(', ')}
Links: ${contact.links.join(', ')}`,
            url: window.location.href,
        };

        if (navigator.share) {
            navigator
                .share(shareData)
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing:', error));
        } else {
            alert('Sharing is not supported on this browser.');
        }
    };

    const handleSearchConfirm = () => {
        const searchTerm = searchInput.toLowerCase();
        const filtered = data.filter((contact) => {
            return (
                contact.name.toLowerCase().includes(searchTerm) ||
                contact.desc.toLowerCase().includes(searchTerm) ||
                contact.phones.some((phone) => phone.includes(searchTerm)) ||
                contact.emails.some((email) => email.toLowerCase().includes(searchTerm)) ||
                contact.address.some((addr) => addr.toLowerCase().includes(searchTerm)) ||
                contact.links.some((link) => link.toLowerCase().includes(searchTerm))
            );
        });

        setFilteredContacts(filtered);
    };

    const addTwoInputs = (field) => {
        setNewContact((prev) => ({
            ...prev,
            [field]: [...prev[field], ['', '']], // Add a new row of two empty inputs
        }));
    };

    const removeTwoInputs = (field) => {
        setNewContact((prev) => ({
            ...prev,
            [field]: prev[field].slice(0, Math.max(1, prev[field].length - 1)), // Ensure at least one row remains
        }));
    };

    const updateInputValue = (field, rowIndex, colIndex, value) => {
        setNewContact((prev) => {
            const updatedField = [...prev[field]];
            updatedField[rowIndex][colIndex] = value; // Update the specific input value
            return { ...prev, [field]: updatedField };
        });
    };

    const handleSetType = (type) => {
        setNewContact((prev) => ({
            ...prev,
            type, // Set as 0 for Person or 1 for Company
        }));
        console.log("Selected type:", type === 0 ? "person" : "company"); // Debug log
    };



    const toggleFavorite = () => {
        // Toggle the favorite state (this will control the image)
        setIsFavorite((prev) => !prev);

        // Temporarily activate for 500ms
        setIsFavoriteTemporary(true);
        setTimeout(() => {
            setIsFavoriteTemporary(false);
        }, 200);
    };

    const handleConfirmAdd = () => {
        // Validate required fields (name and type)
        if (!newContact.name.trim() || newContact.type === '') {
            alert('Please fill in the required fields (name and type).');
            return;
        }

        const payload = {
            name: newContact.name,
            desc: newContact.desc,
            phones: newContact.phones.flat().filter(value => value.trim()),
            emails: newContact.emails.flat().filter(value => value.trim()),
            address: newContact.locations.flat().filter(value => value.trim()),
            links: newContact.links.flat().filter(value => value.trim()),
            favorite: isFavorite ? 1 : 0, // Use the isFavorite state here
            type: newContact.type === 0 ? "person" : "company",
            company_id: 1, // Default company ID
        };

        axios.post("https://data.nadzor.app/api/admin_panel/cc/create.php", payload)
            .then((response) => {
                if (response.data.status === 200) {
                    console.log("Contact created successfully:", response.data);

                    const newContactWithDefaults = {
                        ...payload,
                        id: response.data.contact_id, // Use the ID returned from the API
                    };

                    setData(prev => [...prev, newContactWithDefaults]);
                    setFilteredContacts(prev => [...prev, newContactWithDefaults]);
                    resetForm(); // Reset the form after a successful submission
                } else {
                    console.error("Error creating contact:", response.data.message);
                }
            })
            .catch((error) => {
                console.error("Error:", error.response?.data || error.message);
            });
    };


    const highlightText = (text, searchTerm) => {
        if (!searchTerm) return text; // No search term, return text as is
        const regex = new RegExp(`(${searchTerm})`, 'gi'); // Match search term (case-insensitive)
        return text.replace(regex, '<span class="highlight">$1</span>'); // Wrap matches in <span>
    };

    const handleContactRender = (contact) => ({
        ...contact,
        phones: contact.phones || [],
        emails: contact.emails || [],
        address: contact.address || [],
        links: contact.links || [],
    });

    const handleToggleFavorite = (contactId) => {
        const updatedContacts = data.map((contact) => {
            if (contact.id === contactId) {
                return { ...contact, favorite: contact.favorite ? 0 : 1 }; // Toggle favorite status
            }
            return contact;
        });

        setData(updatedContacts);
        setFilteredContacts(updatedContacts);

        const updatedContact = updatedContacts.find(contact => contact.id === contactId);

        // Send request to updateFavorite.php
        axios.post("https://data.nadzor.app/api/admin_panel/cc/updateFavorite.php", {
            id: updatedContact.id,
            favorite: updatedContact.favorite // Only send favorite field
        })
            .then(response => {
                if (response.data.status !== 200) {
                    console.error("Failed to update favorite status:", response.data.message);
                }
            })
            .catch(error => {
                console.error("Error updating favorite status:", error);
            });
    };

    const resetForm = () => {
        setNewContact({
            name: '',
            desc: '',
            phones: [['', '']],
            emails: [['', '']],
            locations: [['', '']],
            links: [['', '']],
            type: '',
            favorite: false,
        });
        setIsAddActive(false);
        setIsEditing(false);
        setEditingContactId(null);
    };

    const handleSubmitContact = async () => {
        const payload = {
            name: newContact.name,
            desc: newContact.desc,
            phones: newContact.phones.flat().filter(value => value.trim()),
            emails: newContact.emails.flat().filter(value => value.trim()),
            address: newContact.locations.flat().filter(value => value.trim()),
            links: newContact.links.flat().filter(value => value.trim()),
            favorite: isFavorite ? 1 : 0, // Get favorite status from state
            type: newContact.type === 0 ? 'person' : 'company',
            company_id: 1, // Default company ID
        };

        try {
            if (isEditing && editingContactId) {
                // Updating an existing contact
                const response = await axios.post(
                    `https://data.nadzor.app/api/admin_panel/cc/update.php`,
                    { id: editingContactId, ...payload }
                );

                if (response.data.status === 200) {
                    // Update local state
                    const updatedContacts = data.map(contact =>
                        contact.id === editingContactId ? { id: editingContactId, ...payload } : contact
                    );

                    setData(updatedContacts);
                    setFilteredContacts(updatedContacts);
                    resetForm();
                }
            }
        } catch (error) {
            console.error("Error updating contact:", error);
        }
    };



    const handleDeleteContact = async (contactId) => {
        try {
            // Make a POST request to delete the contact
            const response = await axios.post(
                "https://data.nadzor.app/api/admin_panel/cc/delete.php",
                { id: contactId } // Send the contact ID in the request body
            );

            // Check the response
            if (response.data.status === 200) {
                alert("Contact deleted successfully");

                // Refresh the contact list
                fetchContacts(); // Assuming fetchContacts reloads the contact list
            } else {
                console.error("Error deleting contact:", response.data.message);
                alert("Failed to delete contact. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
            alert("An error occurred while deleting the contact.");
        }
    };

    const [isEditing, setIsEditing] = useState(false); // Edit mode
    const [editingContactId, setEditingContactId] = useState(null); // ID of contact being edited

    const handleEditContact = (contact) => {
        setNewContact({
            name: contact.name || '',
            desc: contact.desc || '',
            phones: contact.phones.length > 0 ? contact.phones.map(phone => [phone]) : [['', '']],
            emails: contact.emails.length > 0 ? contact.emails.map(email => [email]) : [['', '']],
            locations: contact.address.length > 0 ? contact.address.map(addr => [addr]) : [['', '']],
            links: contact.links.length > 0 ? contact.links.map(link => [link]) : [['', '']],
            type: contact.type === 'person' ? 0 : 1,
        });

        // This line ensures the favorite status is correctly set from the database
        setIsFavorite(contact.favorite === 1);

        setIsEditing(true);
        setEditingContactId(contact.id);
        setIsAddActive(true); // Open the form
    };



    const isFormReady = newContact.type !== null; // Determine if form inputs are enabled
    const [isCollapsed, setIsCollapsed] = useState(false); // Tracks if the component is collapsed
    const [activeSection, setActiveSection] = useState(''); // Tracks the active section (e.g., 'PRIVATE', 'OTHER')

    return (
        <div className="communication">
            <div ref={wrapperRef} className="provider-list-wrapper">
                {providers.map((provider, index) => (
                    <div
                        key={provider.id}
                        className={`provider-item ${selectedProviderId === provider.id ? "selected" : ""
                            }`}
                    >
                        <button
                            className={`dos-btn ${selectedProviderId === provider.id ? "dos-btn-active" : ""
                                }`}
                            onClick={() => handleButtonClick(provider.id, index)}
                        >
                            {provider.name}
                        </button>
                        {selectedProviderId === provider.id && (
                            <div className="single-provider-wrapper">
                               
                                    <SingleProvider providerTypeId={provider.id} />
                               
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {!selectedProviderId ? (<>
                <div className="contacts-wrapper">

                    {/* Header Buttons */}
                    {/* Header Buttons */}
                    <div className="button-row">
                        {/* Always keep the Plus button at the first place */}
                        <button
                            className={`button-row-single ${isAddActive ? 'dos-btn-active' : ''}`}
                            onClick={handleAddButtonClick}
                        >
                            <img src={isEditing ? Edit : Plus} alt={isEditing ? "Edit Contact" : "Add Contact"} />
                        </button>

                        {isAddActive ? (
                            <>
                                {/* Replace other buttons with User, House, and Star */}
                                <button
                                    className={`button-row-single ${newContact.type === 0 ? 'dos-btn-active' : ''}`}
                                    onClick={() => handleSetType(0)} // Set type as 0 for Person
                                >
                                    <img src={User} alt="Person" />
                                </button>
                                <button
                                    className={`button-row-single ${newContact.type === 1 ? 'dos-btn-active' : ''}`}
                                    onClick={() => handleSetType(1)} // Set type as 1 for Company
                                >
                                    <img src={Company} alt="Company" />
                                </button>
                                {/* <button
                className={`button-row-single ${newContact.favorite ? 'dos-btn-active' : ''}`}
                onClick={toggleFavorite} // Toggle favorite status
            >
                <img src={Star} alt="Favorite" />
            </button> */}
                                <button
                                    className={`button-row-single ${isFavorite ? 'is-favorite' : ''}`}
                                    onClick={toggleFavorite} // Toggle favorite
                                >
                                    <img src={isFavorite ? StarGreen : Star} alt="Favorite" />
                                </button>

                            </>
                        ) : (
                            <>
                                {/* Original buttons when Add form is not active */}
                                <button
                                    className={`button-row-single`}
                                    onClick={toggleSort}
                                >
                                    <img src={Sort} alt="Sort" />
                                </button>
                                <button
                                    className={`button-row-single ${isExpandTemporary ? 'dos-btn-active' : ''}`}
                                    onClick={toggleExpandAll}
                                >
                                    <img src={Expand} alt="Expand/Collapse All" />
                                </button>

                                <button
                                    className={`button-row-single ${isSearchActive ? 'dos-btn-active' : ''}`}
                                    onClick={handleSearchToggle}
                                >
                                    <img src={Search} alt="Search" />
                                </button>
                            </>
                        )}
                    </div>


                    {/* Dynamic Content (Add Contact or Original List) */}
                    {isAddActive ? (
                        <div className="add-contact-form">
                            {newContact.type === 1 || newContact.type === 0 ?
                                <>
                                    {/* Name Input */}
                                    <div className="name-input">
                                        <label htmlFor="name">
                                            {newContact.type === 1 ? "NAZIV KOMPANIJE" : "IME I PREZIME"}
                                        </label>
                                        <input
                                            id="name"
                                            type="text"
                                            value={newContact.name} // Bind to newContact.name
                                            onChange={(e) =>
                                                setNewContact((prev) => ({ ...prev, name: e.target.value })) // Update newContact.name
                                            }
                                        />
                                    </div>

                                    <div className="desc-input">
                                        <label htmlFor="desc">
                                            {newContact.type === 1 ? "DELATNOST/OPIS" : "ZANIMANJE/OPIS"}
                                        </label>
                                        <input
                                            id="desc"
                                            type="text"
                                            value={newContact.desc} // Bind to newContact.desc
                                            onChange={(e) =>
                                                setNewContact((prev) => ({ ...prev, desc: e.target.value })) // Update newContact.desc
                                            }
                                        />
                                    </div>

                                    {/* Phones Section */}
                                    <div className="phones-input">
                                        <div className="phones-input-title">
                                            <img src={Phone} alt="Add Phones Icon" />
                                            <span>TELEFONI</span>
                                        </div>
                                        {newContact.phones.map((phoneRow, index) => (
                                            <div className="single-phone" key={index}>
                                                <div className="single-phone-left">
                                                    <input
                                                        type="text"
                                                        placeholder={`Phone ${index * 2 + 1}`}
                                                        value={phoneRow[0]}
                                                        onChange={(e) => updateInputValue('phones', index, 0, e.target.value)}
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder={`Phone ${index * 2 + 2}`}
                                                        value={phoneRow[1]}
                                                        onChange={(e) => updateInputValue('phones', index, 1, e.target.value)}
                                                    />
                                                </div>
                                                <div className="single-phone-right">
                                                    <button id="add-two-more-phones" onClick={() => addTwoInputs('phones')}>
                                                        <img src={Plus} alt="Add Phones" />
                                                    </button>
                                                    <button id="remove-two-phones" onClick={() => removeTwoInputs('phones')}>
                                                        <img src={Delete} alt="Remove Phones" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>


                                    <div className="emails-input">
                                        <div className="emails-input-title">
                                            <img src={Mail} alt="Add Emails Icon" />
                                            <span>EMAILOVI</span>
                                        </div>
                                        {newContact.emails.map((emailRow, index) => (
                                            <div className="single-email" key={index}>
                                                <div className="single-email-left">
                                                    <input
                                                        type="email"
                                                        placeholder={`Email ${index * 2 + 1}`}
                                                        value={emailRow[0]}
                                                        onChange={(e) => updateInputValue('emails', index, 0, e.target.value)}
                                                    />
                                                    <input
                                                        type="email"
                                                        placeholder={`Email ${index * 2 + 2}`}
                                                        value={emailRow[1]}
                                                        onChange={(e) => updateInputValue('emails', index, 1, e.target.value)}
                                                    />
                                                </div>
                                                <div className="single-email-right">
                                                    <button id="add-two-more-emails" onClick={() => addTwoInputs('emails')}>
                                                        <img src={Plus} alt="Add Emails" />
                                                    </button>
                                                    <button id="remove-two-emails" onClick={() => removeTwoInputs('emails')}>
                                                        <img src={Delete} alt="Remove Emails" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="locations-input">
                                        <div className="locations-input-title">
                                            <img src={Location} alt="Add Locations Icon" />
                                            <span>LOKACIJE</span>
                                        </div>
                                        {newContact.locations.map((locationRow, index) => (
                                            <div className="single-location" key={index}>
                                                <div className="single-location-left">
                                                    <input
                                                        type="text"
                                                        placeholder={`Location ${index * 2 + 1}`}
                                                        value={locationRow[0]}
                                                        onChange={(e) => updateInputValue('locations', index, 0, e.target.value)}
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder={`Location ${index * 2 + 2}`}
                                                        value={locationRow[1]}
                                                        onChange={(e) => updateInputValue('locations', index, 1, e.target.value)}
                                                    />
                                                </div>
                                                <div className="single-location-right">
                                                    <button id="add-two-more-locations" onClick={() => addTwoInputs('locations')}>
                                                        <img src={Plus} alt="Add Locations" />
                                                    </button>
                                                    <button id="remove-two-locations" onClick={() => removeTwoInputs('locations')}>
                                                        <img src={Delete} alt="Remove Locations" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="links-input">
                                        <div className="links-input-title">
                                            <img src={Link} alt="Add Links Icon" />
                                            <span>LINKOVI</span>
                                        </div>
                                        {newContact.links.map((linkRow, index) => (
                                            <div className="single-link" key={index}>
                                                <div className="single-link-left">
                                                    <input
                                                        type="text"
                                                        placeholder={`Link ${index * 2 + 1}`}
                                                        value={linkRow[0]}
                                                        onChange={(e) => updateInputValue('links', index, 0, e.target.value)}
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder={`Link ${index * 2 + 2}`}
                                                        value={linkRow[1]}
                                                        onChange={(e) => updateInputValue('links', index, 1, e.target.value)}
                                                    />
                                                </div>
                                                <div className="single-link-right">
                                                    <button id="add-two-more-links" onClick={() => addTwoInputs('links')}>
                                                        <img src={Plus} alt="Add Links" />
                                                    </button>
                                                    <button id="remove-two-links" onClick={() => removeTwoInputs('links')}>
                                                        <img src={Delete} alt="Remove Links" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                </> : <div className="blurred">
                                    {/* If contact type is not chosen */}
                                    {/* Name Input */}
                                    <div className="name-input">
                                        <label htmlFor="name">IME/NAZIV</label>
                                        <input
                                            id="name"
                                            type="text"
                                            placeholder="name"
                                            value={newContact.name} // Bind to newContact.name
                                            onChange={(e) =>
                                                setNewContact((prev) => ({ ...prev, name: e.target.value })) // Update newContact.name
                                            }
                                            disabled="true"
                                        />
                                    </div>

                                    <div className="desc-input">
                                        <label htmlFor="desc">OPIS</label>
                                        <input
                                            id="desc"
                                            type="text"
                                            placeholder="desc"
                                            value={newContact.desc} // Bind to newContact.desc
                                            onChange={(e) =>
                                                setNewContact((prev) => ({ ...prev, desc: e.target.value })) // Update newContact.desc
                                            }
                                            disabled="true"
                                        />
                                    </div>

                                    {/* Phones Section */}
                                    <div className="phones-input">
                                        <div className="phones-input-title">
                                            <img src={Phone} alt="Add Phones Icon" />
                                            <span>TELEFONI</span>
                                        </div>
                                        {newContact.phones.map((phoneRow, index) => (
                                            <div className="single-phone" key={index}>
                                                <div className="single-phone-left">
                                                    <input
                                                        type="text"
                                                        placeholder={`Phone ${index * 2 + 1}`}
                                                        value={phoneRow[0]}
                                                        onChange={(e) => updateInputValue('phones', index, 0, e.target.value)}
                                                        disabled="true"
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder={`Phone ${index * 2 + 2}`}
                                                        value={phoneRow[1]}
                                                        onChange={(e) => updateInputValue('phones', index, 1, e.target.value)}
                                                        disabled="true"
                                                    />
                                                </div>
                                                <div className="single-phone-right">
                                                    <button disabled="true" id="add-two-more-phones" onClick={() => addTwoInputs('phones')}>
                                                        <img src={Plus} alt="Add Phones" />
                                                    </button>
                                                    <button disabled="true" id="remove-two-phones" onClick={() => removeTwoInputs('phones')}>
                                                        <img src={Delete} alt="Remove Phones" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>


                                    <div className="emails-input">
                                        <div className="emails-input-title">
                                            <img src={Mail} alt="Add Emails Icon" />
                                            <span>EMAILOVI</span>
                                        </div>
                                        {newContact.emails.map((emailRow, index) => (
                                            <div className="single-email" key={index}>
                                                <div className="single-email-left">
                                                    <input
                                                        type="email"
                                                        placeholder={`Email ${index * 2 + 1}`}
                                                        value={emailRow[0]}
                                                        onChange={(e) => updateInputValue('emails', index, 0, e.target.value)}
                                                        disabled="true"
                                                    />
                                                    <input
                                                        type="email"
                                                        placeholder={`Email ${index * 2 + 2}`}
                                                        value={emailRow[1]}
                                                        onChange={(e) => updateInputValue('emails', index, 1, e.target.value)}
                                                        disabled="true"
                                                    />
                                                </div>
                                                <div className="single-email-right">
                                                    <button disabled="true" id="add-two-more-emails" onClick={() => addTwoInputs('emails')}>
                                                        <img src={Plus} alt="Add Emails" />
                                                    </button>
                                                    <button disabled="true" id="remove-two-emails" onClick={() => removeTwoInputs('emails')}>
                                                        <img src={Delete} alt="Remove Emails" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="locations-input">
                                        <div className="locations-input-title">
                                            <img src={Location} alt="Add Locations Icon" />
                                            <span>LOKACIJE</span>
                                        </div>
                                        {newContact.locations.map((locationRow, index) => (
                                            <div className="single-location" key={index}>
                                                <div className="single-location-left">
                                                    <input
                                                        type="text"
                                                        placeholder={`Location ${index * 2 + 1}`}
                                                        value={locationRow[0]}
                                                        onChange={(e) => updateInputValue('locations', index, 0, e.target.value)}
                                                        disabled="true"
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder={`Location ${index * 2 + 2}`}
                                                        value={locationRow[1]}
                                                        onChange={(e) => updateInputValue('locations', index, 1, e.target.value)}
                                                        disabled="true"
                                                    />
                                                </div>
                                                <div className="single-location-right">
                                                    <button disabled="true" id="add-two-more-locations" onClick={() => addTwoInputs('locations')}>
                                                        <img src={Plus} alt="Add Locations" />
                                                    </button>
                                                    <button disabled="true" id="remove-two-locations" onClick={() => removeTwoInputs('locations')}>
                                                        <img src={Delete} alt="Remove Locations" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="links-input">
                                        <div className="links-input-title">
                                            <img src={Link} alt="Add Links Icon" />
                                            <span>LINKOVI</span>
                                        </div>
                                        {newContact.links.map((linkRow, index) => (
                                            <div className="single-link" key={index}>
                                                <div className="single-link-left">
                                                    <input
                                                        type="text"
                                                        placeholder={`Link ${index * 2 + 1}`}
                                                        value={linkRow[0]}
                                                        onChange={(e) => updateInputValue('links', index, 0, e.target.value)}
                                                        disabled="true"
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder={`Link ${index * 2 + 2}`}
                                                        value={linkRow[1]}
                                                        onChange={(e) => updateInputValue('links', index, 1, e.target.value)}
                                                        disabled="true"
                                                    />
                                                </div>
                                                <div className="single-link-right">
                                                    <button disabled="true" id="add-two-more-links" onClick={() => addTwoInputs('links')}>
                                                        <img src={Plus} alt="Add Links" />
                                                    </button>
                                                    <button disabled="true" id="remove-two-links" onClick={() => removeTwoInputs('links')}>
                                                        <img src={Delete} alt="Remove Links" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>}
                            {/* Footer Buttons Row */}
                            {newContact.type === 1 || newContact.type === 0 ?
                                <>
                                    <div className="add-form-footer">
                                        {/* Submit Button */}
                                        <button className="footer-btn" onClick={handleSubmitContact}>
                                            <img src={Slanje} alt="Confirm" />
                                        </button>
                                    </div>
                                </> : <>
                                    {/* Nista */}
                                </>}

                        </div>
                    ) : (
                        <>
                            {/* Search Bar */}
                            {isSearchActive && (
                                <div className="search">
                                    <div className="search-top">
                                        <button
                                            id="phone"
                                            className={
                                                visibleField === 'phone' ? 'dos-btn-active' : ''
                                            }
                                            onClick={() =>
                                                setVisibleField((prev) =>
                                                    prev === 'phone' ? null : 'phone'
                                                )
                                            }
                                        >
                                            <img src={Phone} alt="Phone" />
                                        </button>
                                        <button
                                            id="email"
                                            className={
                                                visibleField === 'email' ? 'dos-btn-active' : ''
                                            }
                                            onClick={() =>
                                                setVisibleField((prev) =>
                                                    prev === 'email' ? null : 'email'
                                                )
                                            }
                                        >
                                            <img src={Mail} alt="Email" />
                                        </button>
                                        <button
                                            id="location"
                                            className={
                                                visibleField === 'location'
                                                    ? 'dos-btn-active'
                                                    : ''
                                            }
                                            onClick={() =>
                                                setVisibleField((prev) =>
                                                    prev === 'location' ? null : 'location'
                                                )
                                            }
                                        >
                                            <img src={Location} alt="Location" />
                                        </button>
                                        <button style={{ visibility: "hidden" }} id="confirm" >
                                            <img src={Search} alt="Confirm" />
                                        </button>
                                        <button
                                            id="filter"
                                            className={`search-top-button`}
                                            onClick={toggleFilterMode}
                                        >
                                            {filterMode === 'personal' && <img src={User} alt="Filter" />}
                                            {filterMode === 'company' && <img src={Company} alt="Filter" />}
                                            {filterMode === 'both' && <img src={Both} alt="Filter" />}
                                        </button>

                                    </div>
                                    <div className="search-bot">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            value={searchInput}
                                            onChange={handleSearchInput} // Updates results live
                                        />


                                    </div>
                                </div>
                            )}

                            {/* Contact List */}
                            <div className="contacts-list">
                                {filteredContacts.map((contact, index) => (
                                    <div className="single-contact" key={contact.id}>
                                        {/* Contact Header */}
                                        <div
                                            className="contact-header"
                                            onClick={() => toggleContact(contact.id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <div className="single-contact-name">
                                                <h3>
                                                    {!isSorted ? <>
                                                        <strong>{`${index + 1}. ${contact.name}`}</strong>
                                                    </> : <>
                                                        <strong>{`${filteredContacts.length - index}. ${contact.name}`}</strong>
                                                    </>
                                                    }
                                                </h3>
                                            </div>
                                            <div className="single-contact-desc">
                                                <span>{contact.desc}</span>
                                                <a
                                                    href="#"
                                                    onClick={(e) => handleCheckRegistered(e, contact)}
                                                >
                                                    <img src={Message} alt="Message" />
                                                </a>
                                            </div>
                                        </div>

                                        {/* Contact Details */}
                                        {(areAllExpanded || expandedContactId === contact.id) && (
                                            <>
                                                {/* Phones Section */}
                                                {visibleField === 'phone' && contact.phones?.length > 0 && (
                                                    <div className="contact-group">
                                                        {contact.phones.map((phone, idx) => (
                                                            <div className="single-phone" key={idx}>
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: highlightText(phone, searchInput),
                                                                    }}
                                                                />
                                                                <a href={`tel:${phone}`}>
                                                                    <img src={Phone} alt="Call" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Emails Section */}
                                                {visibleField === 'email' && contact.emails?.length > 0 && (
                                                    <div className="contact-group">
                                                        {contact.emails.map((email, idx) => (
                                                            <div className="single-email" key={idx}>
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: highlightText(email, searchInput),
                                                                    }}
                                                                />
                                                                <a href={`mailto:${email}`}>
                                                                    <img src={Mail} alt="Email" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Address Section */}
                                                {visibleField === 'location' && contact.address?.length > 0 && (
                                                    <div className="contact-group">
                                                        {contact.address.map((addr, idx) => (
                                                            <div className="single-location" key={idx}>
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: highlightText(addr, searchInput),
                                                                    }}
                                                                />
                                                                <a
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    href={`https://www.google.com/maps?q=${encodeURIComponent(addr)}`}
                                                                >
                                                                    <img src={Location} alt="View on Map" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}

                                                {/* Links Section */}
                                                {visibleField === 'link' && contact.links?.length > 0 && (
                                                    <div className="contact-group">
                                                        {contact.links.map((link, idx) => (
                                                            <div className="single-link" key={idx}>
                                                                <span
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: highlightText(link, searchInput),
                                                                    }}
                                                                />
                                                                <a target="_blank" rel="noopener noreferrer" href={link}>
                                                                    <img src={Link} alt="Visit Website" />
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}


                                                {/* Show All Details If No Filter */}
                                                {!visibleField && (
                                                    <>
                                                        <div className="contact-group">
                                                            {contact.phones.map(
                                                                (phone, idx) => (
                                                                    <div
                                                                        className="single-phone"
                                                                        key={idx}
                                                                    >
                                                                        <span>{phone}</span>
                                                                        <a
                                                                            href={`tel:${phone}`}
                                                                        >
                                                                            <img
                                                                                src={Phone}
                                                                                alt="Call"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                        <div className="contact-group">
                                                            {contact.emails.map(
                                                                (email, idx) => (
                                                                    <div
                                                                        className="single-email"
                                                                        key={idx}
                                                                    >
                                                                        <span>
                                                                            {email}
                                                                        </span>
                                                                        <a
                                                                            href={`mailto:${email}`}
                                                                        >
                                                                            <img
                                                                                src={Mail}
                                                                                alt="Email"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                        <div className="contact-group">
                                                            {contact.address.map(
                                                                (addr, idx) => (
                                                                    <div
                                                                        className="single-location"
                                                                        key={idx}
                                                                    >
                                                                        <span>{addr}</span>
                                                                        {/* <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={`https://www.google.com/maps?q=${encodeURIComponent(
                                                            addr
                                                        )}`}
                                                    >
                                                        <img
                                                            src={
                                                                Location
                                                            }
                                                            alt="View on Map"
                                                        />
                                                    </a> */}
                                                                        <a
                                                                            href="#"
                                                                            onClick={(e) => {
                                                                                e.preventDefault(); // Prevent default navigation
                                                                                handleLocationClick(addr); // Pass the location
                                                                            }}
                                                                        >
                                                                            <img src={Location} alt="View on Map" />
                                                                        </a>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                        <div className="contact-group">
                                                            {contact.links.map(
                                                                (link, idx) => (
                                                                    <div
                                                                        className="single-link"
                                                                        key={idx}
                                                                    >
                                                                        <span>{link}</span>
                                                                        <a
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            href={link}
                                                                        >
                                                                            <img
                                                                                src={Link}
                                                                                alt="Visit Website"
                                                                            />
                                                                        </a>
                                                                    </div>
                                                                )
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}

                                        {/* Contact Footer */}
                                        {(areAllExpanded || expandedContactId === contact.id) && (
                                            <div className="button-row-footer">
                                                <button onClick={() => handleShare(contact)}>
                                                    <img src={Share} alt="Share" />
                                                </button>
                                                <button>
                                                    <img src={Copy} alt="Search" />
                                                </button>
                                                <button
                                                    className={`favorite-button ${contact.favorite ? 'is-favorite' : ''}`}
                                                    onClick={() => {
                                                        console.log(`Toggling favorite for contact ID: ${contact.id}, current favorite status: ${contact.favorite}`);
                                                        handleToggleFavorite(contact.id);
                                                    }}
                                                >
                                                    <img src={contact.favorite ? StarGreen : Star} alt="Favorite" />
                                                </button>


                                                <button
                                                    className="edit-button"
                                                    onClick={() => handleEditContact(contact)}
                                                >
                                                    <img src={Edit} alt="Edit" />
                                                </button>
                                                <button
                                                    className="delete-button"
                                                    onClick={() => handleDeleteContact(contact.id)}
                                                >
                                                    <img src={Delete} alt="Delete" />
                                                </button>
                                            </div>
                                        )}
                                        <hr />
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </>)
                : (<>

                </>)}
                {isModalOpen && (
                    <Modal
                        message="Da li želite da pozovete ovaj kontakt u aplikaciju?"
                        onConfirm={handleModalConfirm}
                        onCancel={() => setIsModalOpen(false)}
                    />
                )}
        </div>
        
    );
}

export default Contacts;
